export enum GalleryGroupTypeEnum {
  GroupByInspectionGroup = 1,
  GroupByFailureReason = 2,
  GroupByArticle = 3,
}